window.McDLaborAPI = new function () {
    "use strict";

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['McDLabor']);

    self.putLocationInfoSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/location_info', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getLocationInfoSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/location_info', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.putFixedHoursSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/fixed_hours', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getFixedHoursSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/fixed_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getJobTitles = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/jobs_titles', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBrandLaborForecast = function (brandId, startDate, endDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            start_week_date: startDate,
            end_week_date: endDate,
            mode: 'BASIC'
        };

        _protected.request('brands/' + brandId + '/labor_forecasts', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAdjustments = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteAdjustment = function (brandId, adjustmentId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!adjustmentId) {
            throw "No adjustment id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustmentId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateLaborForecastProjections = function (brandId, startDate, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var payload = {
            "start_week_date": startDate.format('YYYY-MM-DD'),
            "adjustment": {
                'id': adjustment
            }
        };


        _protected.request('brands/' + brandId + '/forecast', 'PUT', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLaborForecastForWeek = function (brandId, startDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            start_date: startDate
        };

        _protected.request('brands/' + brandId + '/labor_forecasts/week', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.submitLabourForecastForApproval = async (brandId, startDate, note) => {
        const payload = {
            note: note
        }
        const res = await _protected.request(`brands/${brandId}/labor_forecasts/submit?start_week_date=${startDate}`, 'POST', payload);
        if (res?.status === 200 && res?.data?.data) {
            return res.data.data;
        }
        throw res;
    }

    self.approveLabourForecast = async (brandId, startDate) => {
        const res = await _protected.request(`brands/${brandId}/labor_forecasts/approve?start_week_date=${startDate}`, 'POST');
        if (res?.status === 200 && res?.data?.data) {
            return res.data.data;
        }
        throw res;
    }

    self.rejectLabourForecast = async (brandId, startDate, note) => {
        const payload = {
            note: note
        }
        const res = await _protected.request(`brands/${brandId}/labor_forecasts/reject?start_week_date=${startDate}`, 'POST', payload);
        if (res?.status === 200 && res?.data?.data) {
            return res.data.data;
        }
        throw res;
    }

    self.withdrawLabourForecast = async (brandId, startDate, note) => {
        const payload = {
            note: note
        }
        const res = await _protected.request(`brands/${brandId}/labor_forecasts/withdraw?start_week_date=${startDate}`, 'POST', payload);
        if (res?.status === 200 && res?.data?.data) {
            return res.data.data;
        }
        throw res;
    }

    self.getLabourForecastApprovalFlowAudits = async (brandId, startDate) => {
        const params = {
            start_week_date: startDate
        }
        const res = await _protected.request(`brands/${brandId}/labor_forecasts/audits`, 'GET', params);
        if (res?.status === 200 && res?.data?.data && Array.isArray(res.data.data.audits)) {
            return res.data.data.audits;
        }
        throw res;
    }

    self.generateLaborForecast = function (brandId, generateData) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            start_date: generateData.start_date,
        };

        if (generateData.reset_adjustments) {
            params.reset_adjustments = true;
        } else {
            params.reset_adjustments = false;
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/generate', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNewAdjustment = function (brandId, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'POST', adjustment)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateAdjustment = function (brandId, adjustment) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!adjustment.id) {
            throw "No adjustment id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustment.id, 'PUT', adjustment)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.adjustmentPartialUpdate = function (brandId, adjustmentId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!adjustmentId) {
            throw "No adjustment id";
        }

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustmentId, 'PATCH', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getMcDSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getOperatingRevenueHoursRules = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_revenue_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateOperatingRevenueHoursRule = function (brandId, ruleId, rule) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_revenue_hours/' + ruleId, 'PUT', rule)
            .then(function (res) {
                if (res && res.data && res.data.data && (res.status === 200 || res.status === 201)) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.createNewOperatingRevenueHoursRule = function (brandId, rule) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_revenue_hours', 'POST', rule)
            .then(function (res) {
                if (res && res.data && res.data.data && (res.status === 200 || res.status === 201)) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteOperatingRevenueHoursRule = function (brandId, ruleId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!ruleId) {
            throw "No rule id";
        }

        _protected.request('brands/' + brandId + '/settings/operating_revenue_hours/' + ruleId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBreakfastEndTimes = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/breakfast_time', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBreakfastEndTimeRules = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/breakfast_time', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBreakfastEndTimeRule = function (brandId, ruleId, rule) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/breakfast_time/' + ruleId, 'PUT', rule)
            .then(function (res) {
                if (res && res.data && res.data.data && (res.status === 200 || res.status === 201)) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createBreakfastEndTimeRule = function (brandId, rule) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/breakfast_time', 'POST', rule)
            .then(function (res) {
                if (res && res.data && res.data.data && (res.status === 200 || res.status === 201)) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteBreakfastEndTimeRule = function (brandId, ruleId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!ruleId) {
            throw "No rule id";
        }

        _protected.request('brands/' + brandId + '/settings/breakfast_time/' + ruleId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBusinessSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/business/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.updateBusinessSettings = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/business/settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBusinessManagementMode = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/business/settings/management_mode', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.PRODUCTIVITY_MATRIX_TYPES = {
        HIGH_PRODUCTIVITY: 'HIGH_PRODUCTIVITY',
        STANDARD: 'STANDARD'
    }

    self.LABOR_EFFICIENCY_TYPES = {
        TPMH: 'TPMH',
        PUNCHED_LABOR: 'PUNCHED_LABOR'
    }

    self.MANAGEMENT_MODES = {
        BAM_AND_TOP_LEVEL: 'BAM_AND_TOP_LEVEL',
        BAM_LEVEL: 'BAM_LEVEL',
        LOCATION_LEVEL: 'LOCATION_LEVEL'
    }

    self.SETTINGS_ATTRIBUTES = {
        ALLOWANCE_PERCENTAGE: 'ALLOWANCE_PERCENTAGE',
    }

};
